export const getServerLocale = (locale?: string): { app: string; contentManagerSystem: string } => {
  const brazil = ['pt-BR', 'pt-br', 'pt']
  const english = ['en', 'en-US', 'en-us']

  if (locale)
    if (brazil.includes(locale)) {
      return { app: 'pt-br', contentManagerSystem: 'pt_BR' }
    }

  if (locale)
    if (english.includes(locale)) {
      return { app: 'en', contentManagerSystem: 'en' }
    }

  return { app: 'pt-br', contentManagerSystem: 'pt_BR' }
}
